function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getRefName, getRowKey, getFlatColumns } from './utils';
import SubMixin from './mixins/sub';
import ExpanderMixin from './mixins/expander';
import TableRow from './tableRow';
export default {
  name: 'TableBody',
  components: {
    TableRow: TableRow
  },
  mixins: [SubMixin, ExpanderMixin],
  computed: {
    rowRefName: function rowRefName() {
      return getRefName(this.fixed, 'tableRowRef');
    },
    expandRowRefName: function expandRowRefName() {
      return getRefName(this.fixed, 'expandRowsRef');
    },
    cols: function cols() {
      return getFlatColumns(this);
    }
  },
  mounted: function mounted() {
    this.saveRowRef();
  },
  updated: function updated() {
    this.saveRowRef();
  },
  methods: {
    saveRowRef: function saveRowRef() {
      var fixed = this.fixed,
          $refs = this.$refs,
          elementRefs = this.elementRefs,
          rowRefName = this.rowRefName,
          expandRowRefName = this.expandRowRefName,
          expandedRowRender = this.expandedRowRender,
          rootScopedSlots = this.rootScopedSlots,
          updateRowHeightAndScrollPosition = this.updateRowHeightAndScrollPosition;
      var changeCnt = 0;

      if (!(rowRefName in elementRefs) || !elementRefs[rowRefName]) {
        this.saveRef(rowRefName, $refs[rowRefName]);
        changeCnt += 1;
      }

      if (!fixed) {
        if ((!!expandedRowRender || rootScopedSlots.expand) && (!(expandRowRefName in elementRefs) || !elementRefs[expandRowRefName])) {
          this.saveRef(expandRowRefName, $refs[expandRowRefName]);
          changeCnt += 1;
        }
      }

      if (changeCnt > 0) {
        updateRowHeightAndScrollPosition();
      }
    },

    /**
     * 渲染数据行
     * @param {Array} rowDatas 数据
     * @param {Number} indent 层级
     * @param {Object} rowProps 行的额外属性
     * @param {Boolean} needExpand 是否可展开
     * @param {Array} ancestorKeys 当前行的所有父级, 用于判断当前行的隐藏和显示
     */
    renderRows: function renderRows(rowDatas, indent, rowProps) {
      var needExpand = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var ancestorKeys = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
      var h = this.$createElement;
      var prefixCls = this.prefixCls,
          rowKey = this.rowKey,
          cols = this.cols,
          fixed = this.fixed,
          rowRefName = this.rowRefName,
          renderExpandRows = this.renderExpandRows;
      var nRowProps = rowProps; // const needIndentSpaced = getNeedIndentSpaced(rowDatas);

      return rowDatas.map(function (record) {
        var idx = nRowProps.idx;

        var nRecord = _objectSpread({}, record);

        var key = getRowKey(rowKey, nRecord, idx);
        var nextAcestorKeys = [].concat(_toConsumableArray(ancestorKeys), [key]);
        var rows = [h("table-row", {
          "attrs": {
            "rowPrefixCls": "".concat(prefixCls, "-row"),
            "cols": cols,
            "record": nRecord,
            "rowIdx": idx,
            "fixed": fixed,
            "uid": key,
            "ancestorKeys": ancestorKeys,
            "indent": indent,
            "needExpand": needExpand,
            "needIndentSpaced": true
          },
          "ref": rowRefName,
          "refInFor": true,
          "key": key
        })];
        nRowProps.idx += 1;
        rows.push.apply(rows, _toConsumableArray(renderExpandRows(nRecord, indent, nRowProps, nextAcestorKeys)));
        return rows;
      });
    }
  },
  render: function render() {
    var h = arguments[0];
    var prefixCls = this.prefixCls,
        renderRows = this.renderRows,
        childColName = this.childColName,
        innerRecords = this.innerRecords; // 这边拿innverRecords渲染，因为涉及到拖拽，可能会修改数据排序

    var needExpand = innerRecords.some(function (v) {
      return v[childColName] && v[childColName].length;
    }); // const needExpand = records.some(v => v[childColName] && v[childColName].length);

    return h("tbody", {
      "class": "".concat(prefixCls, "-tbody")
    }, [renderRows(innerRecords, 0, {
      idx: 0
    }, needExpand, [])]); // return (
    //   <tbody class={`${prefixCls}-tbody`}>{renderRows(records, 0, rowProps, needExpand, [])}</tbody>
    // );
  }
};